var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import BaseButton, { TYPES } from './BaseButton';
export var SIZES = {
    L: 'l',
    M: 'm'
};
// Brand colored button
export var Primary = function (props) { return (_jsx(BaseButton, __assign({}, props, { buttonType: TYPES.PRIMARY, children: props.children }))); };
// Same as primary with neutral color
export var Secondary = function (props) { return (_jsx(BaseButton, __assign({}, props, { buttonType: TYPES.SECONDARY, children: props.children }))); };
export var Ghost = function (props) { return (_jsx(BaseButton, __assign({}, props, { buttonType: TYPES.GHOST, children: props.children }))); };
// Transparent background with border
export var Outline = function (props) { return (_jsx(BaseButton, __assign({}, props, { buttonType: TYPES.OUTLINE, children: props.children }))); };
// Transparent background with brand-colored border
export var OutlineBrand = function (props) { return (_jsx(BaseButton, __assign({}, props, { buttonType: TYPES.OUTLINE_BRAND, children: props.children }))); };
export var OutlineBrandCard = function (props) { return (_jsx(BaseButton, __assign({}, props, { buttonType: props.active ? TYPES.OUTLINE_BRAND_CARD_ACTIVE : TYPES.OUTLINE_BRAND_CARD, children: props.children }))); };
export var RawButton = function (props) { return (_jsx(BaseButton, __assign({}, props, { children: props.children }))); };
export default Primary;
